import React, { useMemo } from "react"
import { Card, CardBody, Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import VehicleContentSidebar from "./VehicleContentSidebar"
import VehicleStockPublishList from "./VehicleStockPublishList"
import { useListParams } from "hooks/useListParams"
import { useVehicleStockPublishes } from "hooks/useVehicleStockPublishes"

export default function PostStockList() {
  document.title = "Vehicle Content List"

  
  const { data: counts } = useVehicleStockPublishes()
  const countsData = counts?.data?.count ?? []

  const { params, setPage, setSearch, updateParams } = useListParams({
    page: 1,
    search: "",
    slug: "bikroy",
    p_all: "all",
  })

  // Memoize params to prevent unnecessary re-renders
  const memoizedParams = useMemo(
    () => params,
    [
      params.page,
      params.search,
      params.slug,
      params.pending,
      params.p_modal,
      params.stock_id,
      params.p_page,
      params.p_all,
    ]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Content Manager"
            breadcrumbItem="Vehicle Content List"
          />
          <div className="d-xl-flex">
            <div className="w-100">
              <div className="d-md-flex">
                <VehicleContentSidebar
                  params={memoizedParams}
                  updateParams={updateParams}
                  data={countsData}
                />
                <div className="w-100">
                  <Card>
                    <CardBody>
                      <VehicleStockPublishList
                        params={memoizedParams}
                        updateParams={updateParams}
                        setPage={setPage}
                        setSearch={setSearch}
                        countsData={countsData}
                      />
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}
